import React, { Component } from 'react'
import { browserIs } from 'tools/browser'
import DesktopHeader from 'organisms/Header/DesktopHeader'
import MobileHeader from 'organisms/Header/MobileHeader'
import { BrowserProvider, BrowserConsumer } from 'contexts/browser-context'
import { ThemeProvider, themes } from 'contexts/theme-context'
import PropTypes from 'prop-types'
import { ConfigProvider } from 'contexts/config-context'
import { ProfileProvider } from 'contexts/profile-context'
import { SettingsProvider } from 'contexts/settings-context'
import RootErrorBoundary from 'atoms/RootErrorBoundary'

class Header extends Component {
  state = {
    browserIs: null,
  }

  componentDidMount() {
    const newState = {
      browserIs: browserIs(),
    }

    this.setState(newState)
    window.addEventListener('resize', () => {
      window.requestAnimationFrame(() => {
        this.setState({ browserIs: browserIs() })
      })
    })
  }

  render() {
    const { browserIs } = this.state
    const { config } = this.props

    if (!config) {
      return null
    }

    if (browserIs === null) {
      return null
    }

    return (
      <RootErrorBoundary>
        <SettingsProvider>
          <ConfigProvider value={config}>
            <ProfileProvider config={config}>
              <ThemeProvider value={themes[config.theme]}>
                <BrowserProvider value={browserIs}>
                  <BrowserConsumer>
                    {(browserIs) => (browserIs.greaterThan.large ? <DesktopHeader /> : <MobileHeader />)}
                  </BrowserConsumer>
                </BrowserProvider>
              </ThemeProvider>
            </ProfileProvider>
          </ConfigProvider>
        </SettingsProvider>
      </RootErrorBoundary>
    )
  }
}
Header.propTypes = {
  config: PropTypes.object.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/Header.js